<div class="button-wrapper">
  @if (buttonTemplate) {
    <ng-template *ngTemplateOutlet="buttonTemplate; context: { toggleActionSheet }"></ng-template>
  } @else {
    <pxw-button
      [rounded]="true"
      size="md"
      [appareance]="appareance"
      [disabled]="disabled"
      [color]="background"
      (click)="actionSheet.visible = true"
      iconPosition="right"
    >
      <pxw-icon icon="chevron-down" />
      {{ label }}
    </pxw-button>
  }
  <div class="dropdown-target" #actionSheetTarget></div>
</div>
<dx-action-sheet
  #actionSheet
  [usePopover]="usePopover"
  [target]="actionSheetTarget"
  [items]="[{}]"
  [showTitle]="false"
  [cancelText]="cancelText"
  [width]="usePopover ? width : undefined"
>
  <div
    class="dropdown-content size-{{ size }} device-{{ device }}"
    *dxTemplate="let item of 'item'"
  >
    <ng-content></ng-content>
  </div>
</dx-action-sheet>
